// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"33bcab36","317":"49ebc8c5","453":"a8c3d6b7","805":"d7e6355e","874":"6a0c5a05"}[chunkId] + ".chunk.js";
};